import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { CartServiceProps } from '../../types';
import { CartContext } from '../../Cart';
import { ServiceOptionItem, ServiceSummaryOptionsType } from '../../../ServiceSummary/types';
import { CheckoutSteps } from '../../../MobileStepbar/types';
import ServiceSummaryDivider from '../../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import ServiceSummaryOption from '../../../ServiceSummary/components/ServiceSummaryOption';
import InsuranceSummary from '../../../ServiceSummary/services/InsuranceSummary';
import { CdnIcon } from '@shared/ui';

const Insurance: React.FC<CartServiceProps> = ({ services, separateInsurance, renderService, onServiceDelete }) => {
	const { t } = useTranslation('Cart');

	const cartConfig = React.useContext(CartContext);

	if (!services.insurances?.selectedInsurances?.length && !renderService) {
		return null;
	}

	const renderContent = useCallback(
		(items: ServiceOptionItem[]) => {
			const group: ServiceSummaryOptionsType = {
				header: t('Insurances'),
				items,
				headerIcon: <CdnIcon icon={'Services/Insurance'} />
			};

			const content = items.length ? (
				<ServiceSummaryDivider>
					<ServiceSummaryOption groupOption={separateInsurance ? { items } : group} />
				</ServiceSummaryDivider>
			) : null;

			if (separateInsurance && renderService) {
				return renderService(
					CheckoutSteps.Insurance,
					{ header: group.header, icon: group.headerIcon, totalPrice: cartConfig.totalPrices?.insurance },
					content
				);
			}

			return content;
		},
		[separateInsurance, renderService]
	);

	return (
		<InsuranceSummary
			selectedInsurances={services.insurances?.selectedInsurances}
			onServiceDelete={onServiceDelete}
		>
			{renderContent}
		</InsuranceSummary>
	);
};

export default Insurance;
